angular
    .module("skillBuilderSaaS")
    .filter("highlight", ["$sce", function ($sce) {
        return function (text, phrase) {
            if (phrase)
                text = text.replace(new RegExp("(" + phrase + ")", "gi"), "<span class=\"search-highlight\">$1</span>");
            return $sce.trustAsHtml(text);
        };
    }]);
